module.exports = __webpack_public_path__ + "img/metamask.925c6160.svg";